module.exports = __webpack_public_path__ + "img/wahana.571f32bd.png";